import { css } from '@emotion/core'

export default {
  searchCss: () => ({
    xl: css`
      display: flex;
      justify-content: flex-end;
      padding-top: 5px;
    `,
    default: css`
      display: flex;
      justify-content: flex-start;
      max-width: 440px;
      padding-top: 16px;
    `,
  }),
}
